// The estate item types a client can add, from EstateItemType in webapp-alpha
// (app/common/global_models/probate/estate_types.py). `fields` picks the Add form's questions. A type
// with an institution is one we write to, so the client names the provider and we describe the item
// from it.
export const ESTATE_ITEM_TYPES = {
  bank_account: {
    label: "Bank or building society account",
    short: "Bank account",
    addLabel: "Add an account",
    fields: "institution",
    institution: "bank",
    noun: "account",
    nameHint: "The bank or building society",
  },
  shares_and_investments: {
    label: "Shares or investments",
    short: "Investments",
    addLabel: "Add an investment",
    fields: "institution",
    institution: "investment_platform",
    noun: "investments",
    nameHint: "The investment provider",
  },
  pension: {
    label: "Pension",
    short: "Pension",
    addLabel: "Add a pension",
    fields: "institution",
    institution: "pension_provider",
    noun: "pension",
    nameHint: "The pension provider",
  },
  life_insurance: {
    label: "Life insurance policy",
    short: "Life insurance",
    addLabel: "Add a policy",
    fields: "institution",
    institution: "insurer",
    noun: "life insurance",
    nameHint: "The insurer",
  },
  credit_card: {
    label: "Credit card",
    short: "Credit card",
    addLabel: "Add a credit card",
    fields: "institution",
    institution: "lender",
    noun: "credit card",
    nameHint: "The card provider",
    referenceLabel: "Last 4 digits of the card",
    // We never want a full card number, even when one is typed
    lastFourDigitsOnly: true,
  },
  loan: {
    label: "Loan",
    short: "Loan",
    addLabel: "Add a loan",
    fields: "institution",
    institution: "lender",
    noun: "loan",
    nameHint: "The lender",
  },
  overdraft: {
    label: "Overdraft",
    short: "Overdraft",
    addLabel: "Add an overdraft",
    fields: "institution",
    institution: "bank",
    noun: "overdraft",
    nameHint: "The bank",
  },
  vehicle: { label: "Vehicle", short: "Vehicle", addLabel: "Add a vehicle", fields: "vehicle" },
  household_goods: { label: "Valuable", short: "Valuable", addLabel: "Add a valuable", fields: "valuable" },
  money_owed_to_deceased: {
    label: "Money owed to them",
    short: "Money owed",
    addLabel: "Add money owed to them",
    fields: "owed",
  },
};

export const ADDABLE_TYPES = Object.keys(ESTATE_ITEM_TYPES);

// Types a request row lists but a client can't add, named for the list only
const LISTED_ONLY_LABELS = { arrears: "Arrears", tax_owed: "Tax owed", other_liability: "Other debt" };

export const estateItemShortLabel = (itemType) => ESTATE_ITEM_TYPES[itemType]?.short ?? LISTED_ONLY_LABELS[itemType];

// A request row that adds more than one type names them together
const ROW_COPY = {
  "bank_account,shares_and_investments": {
    addLabel: "Add an account",
    nameHint: "The bank, building society or investment provider",
  },
  "pension,life_insurance": { addLabel: "Add a pension or policy", nameHint: "The pension provider or insurer" },
  "credit_card,loan,overdraft": { addLabel: "Add a card or loan", nameHint: "The card provider, lender or bank" },
};

export const addFormCopy = (types) => {
  if (types.length === 1) {
    const { addLabel, nameHint } = ESTATE_ITEM_TYPES[types[0]];
    return { addLabel, nameHint };
  }
  return ROW_COPY[types.join(",")] ?? { addLabel: "Add an item" };
};
